<app-page-header [heading]="'Rate Sheet List'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div class="page-panel ">
  <div class="row">
    <div class="col-lg-4 pull-right">
      <input (click)="getCurrentlist()" [checked]="checked"
             class="text-center" type="checkbox">&nbsp;&nbsp;Show valid rate list
    </div>
    <div class="col-lg-4  d-flex justify-content-end align-items-center">
      <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/purchase-order/supplier-price"
         title="Create rate sheet">&nbsp;<i
        class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
    </div>
    <div class="col-lg-4">
      <div class="input-group">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="purchase.search_purchase" class="form-control"
               id="typeahead-http"
               name="search_text" placeholder="Supplier / Item / From - to Date..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="purchase.search_purchase != ''" class="fa fa-close"></i>
            <i *ngIf="purchase.search_purchase == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="">
    <table class="table tbl table-hover table-striped table-bordered">
      <thead class="text-center">
      <tr>
        <th (click)="setOrder('SUPPLIER_PRICE_ID')" [class.active]="order == 'SUPPLIER_PRICE_ID'"
            width="1%">
        </th>
        <th width="1%">
          #
        </th>
        <th (click)="setOrder('VENDOR_NAME')" [class.active]="order == 'VENDOR_NAME'"
            style="cursor: pointer;">
          Supplier <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
        </th>
        <th (click)="setOrder('TRADE_NAME')" [class.active]="order == 'TRADE_NAME'"
            style="cursor: pointer;">
          Item <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
        </th>
        <th (click)="setOrder('FROM_DATE')" [class.active]="order == 'FROM_DATE'"
            class="mdl-data-table__cell--non-numeric"
            style="cursor: pointer;" width="10%">
          From Date <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
        </th>
        <th (click)="setOrder('TO_DATE')" [class.active]="order == 'TO_DATE'" style="cursor: pointer;"
            width="8%">
          To Date <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
        </th>
        <th (click)="setOrder('RATE')" [class.active]="order == 'RATE'" style="cursor: pointer;"
            width="8%">
          Rate <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
        </th>
        <th (click)="setOrder('VAT_AMOUNT')" [class.active]="order == 'VAT_AMOUNT'" style="cursor: pointer;"
            width="8%">
          VAT <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
        </th>
        <th (click)="setOrder('PRICE')" [class.active]="order == 'PRICE'" style="cursor: pointer;"
            width="8%">
          Total <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
        </th>
        <th width="5%">Action</th>
      </tr>
      <tr *ngIf="(purchase_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of purchase_data | orderBy: order:reverse:true;let i = index" style="font-size: 12px">
        <td class="text-center">
          <label>
            <input (change)="updateChecked(i,data.SUPPLIER_PRICE_ID)"
                   name="check"
                   type="checkbox"
                   value="{{data.CHECKED}}"/>
          </label>
        </td>
        <td class="text-center"> {{ start + i + 1 }}</td>
        <td>{{ data.VENDOR_NAME }}<br>{{ data.VENDOR_PHONE }}</td>
        <td>{{ data.TRADE_NAME }}</td>
        <td>{{ data.FROM_DATE }}</td>
        <td>{{ data.TO_DATE }}</td>
        <td class="text-right">{{ data.RATE }}</td>
        <td class="text-right">{{ data.VAT_AMOUNT }}</td>
        <td class="text-right">{{ data.PRICE }}</td>
        <td>
          <button (click)="delete(data)" alt="Delete" class="btn btn-sm btn-danger" style="font-size: 12px;"
                  title="Delete"><i class="fa fa-trash"></i></button>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="text-center">
      <button (click)="addList()" class="btn btn-sm btn-primary" style="font-size: 12px;">Add</button>
      <ng-container *ngIf="rate_list.length > 0">
        &nbsp;&nbsp;&nbsp;<button (click)="popupData();" class="btn btn-sm btn-primary" style="font-size: 12px;">Show
      </button>
      </ng-container>
      <ng-container *ngIf="rate_list.length > 0">
        &nbsp;&nbsp;&nbsp;<button (click)="listaddSupplierPrice();open(content);" class="btn btn-sm btn-primary"
                                  style="font-size: 12px;">Show
      </button>
      </ng-container>
      &nbsp;&nbsp;&nbsp;<button (click)="clear_all()" class="btn btn-sm btn-primary" style="font-size: 12px;">Clear
      all
    </button>

      <div class="clearfix"></div>
      <div class="clearfix"></div>
    </div>
    <app-pagination (pageChange)="getPurchaseList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>
<ng-template #content let-modal>
  <div class="modal-header" style="background-color: #bbd6f1;">
    <div class="pull-right">
      <h5 class="modal-title" id="modal-basic-title">
        Create Purchase Order
      </h5>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="panel panel-default">
          <div class="panel-heading"></div>
        </div>
        <div class="panel-body">
          <table class="table tbl table-bordered">
            <tbody>
            <ng-container *ngFor="let rate of rate_list;let j=index">
              <tr style="font-weight: bolder;">
                <td colspan="5">
                  <label>
                    <input (change)="itemChecked(j)"
                           name="options"
                           type="checkbox"
                           value="{{rate.CHECK}}"/>
                  </label>&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ rate.VENDOR_NAME }}
                </td>
              </tr>
              <tr *ngFor="let item of rate.ITEMS;let i=index">

                <td width="1%">{{ i + 1 }}</td>
                <td>{{ item.TRADE_NAME }}</td>
                <td width="8%">{{ item.PRICE }}</td>
                <td width="1%">
                  <button (click)="delete_rate(item)" alt="Delete" class="btn btn-sm btn-danger"
                          style="font-size: 12px;"
                          title="Delete"><i class="fa fa-close"></i></button>
                </td>
              </tr>
              <tr style="font-weight: bolder;">
                <td colspan="3">Total</td>
                <td>{{ rate.TOTAL | number : '1.2-2' }}</td>
              </tr>
            </ng-container>
            </tbody>
          </table>
          <div class="text-center">
            <button (click)="modal.dismiss('Cross click')" class="btn btn-sm btn-warning"
                    style="font-size: 12px;color:#fff">Close
            </button>&nbsp;&nbsp;&nbsp;&nbsp;
            <ng-container *ngIf="rate_list.length>0">
              <button (click)="createPO()" class="btn btn-sm btn-info" style="font-size: 12px;">Create PO</button>&nbsp;&nbsp;&nbsp;&nbsp;
            </ng-container>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
